export default __webpack_public_path__ + "static/lb-afe57690786de70e4b182425efda8b82.svg";